import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	storyPointsBelowTargetTooltip: {
		id: 'sprint-commitment-indicator.story-points-below-target-tooltip',
		defaultMessage:
			'{committed, plural, one {# story point} other {# story points}} committed (under recommended target of {lowTarget}-{highTarget})',
		description: 'Indicates the sprint commitment is under target and uses story points',
	},
	storyPointsWithinTargetTooltip: {
		id: 'sprint-commitment-indicator.story-points-within-target-tooltip',
		defaultMessage:
			'{committed, plural, one {# story point} other {# story points}} committed (falls within recommended target of {lowTarget}-{highTarget})',
		description: 'Indicates the sprint commitment is within target and uses story points',
	},
	storyPointsAboveTargetTooltip: {
		id: 'sprint-commitment-indicator.story-points-above-target-tooltip',
		defaultMessage:
			'{committed, plural, one {# story point} other {# story points}} committed (over recommended target of {lowTarget}-{highTarget})',
		description: 'Indicates the sprint commitment is over target and uses story points',
	},
	issueCountBelowTargetTooltip: {
		id: 'sprint-commitment-indicator.issue-count-below-target-tooltip',
		defaultMessage:
			'{committed, plural, one {# issue} other {# issues}} committed (under recommended target of {lowTarget}-{highTarget})',
		description: 'Indicates the sprint commitment is within target',
	},
	issueCountWithinTargetTooltip: {
		id: 'sprint-commitment-indicator.issue-count-within-target-tooltip',
		defaultMessage:
			'{committed, plural, one {# issue} other {# issues}} committed (falls within recommended target of {lowTarget}-{highTarget})',
		description: 'Indicates the sprint commitment is within target',
	},
	issueCountAboveTargetTooltip: {
		id: 'sprint-commitment-indicator.issue-count-above-target-tooltip',
		defaultMessage:
			'{committed, plural, one {# issue} other {# issues}} committed (over recommended target of {lowTarget}-{highTarget})',
		description: 'Indicates the sprint commitment is within target',
	},
	timeTrackingBelowTargetTooltip: {
		id: 'sprint-commitment-indicator.time-tracking-below-target-tooltip',
		defaultMessage: '{committed} committed (under recommended target of {lowTarget}-{highTarget})',
		description: 'Indicates the sprint commitment is within target',
	},
	timeTrackingWithinTargetTooltip: {
		id: 'sprint-commitment-indicator.time-tracking-within-target-tooltip',
		defaultMessage:
			'{committed} committed (falls within recommended target of {lowTarget}-{highTarget})',
		description: 'Indicates the sprint commitment is within target',
	},
	timeTrackingAboveTargetTooltip: {
		id: 'sprint-commitment-indicator.time-tracking-above-target-tooltip',
		defaultMessage: '{committed} committed (over recommended target of {lowTarget}-{highTarget})',
		description: 'Indicates the sprint commitment is within target',
	},
	belowTargetLabel: {
		id: 'sprint-commitment-indicator.below-target-label',
		defaultMessage: 'Sprint below target',
		description: 'Indicates the sprint commitment is above target',
	},
	withinTargetLabel: {
		id: 'sprint-commitment-indicator.within-target-label',
		defaultMessage: 'Sprint within target',
		description: 'Indicates the sprint commitment is above target',
	},
	aboveTargetLabel: {
		id: 'sprint-commitment-indicator.above-target-label',
		defaultMessage: 'Sprint above target',
		description: 'Indicates the sprint commitment is above target',
	},
	insightsButton: {
		id: 'sprint-commitment-indicator.insights-button',
		defaultMessage: 'Insights',
		description: 'Button to show insights panel',
	},
});
